import React from "react";
import { Card, Text, BlockStack, InlineStack, Avatar, Thumbnail } from "@shopify/polaris";
import { PieChart } from "react-minimal-pie-chart";
import CustomPieChart from "app/analytics/modules/provider/pieChart";
import { ProductAnalyticStyle } from "app/analytics/modules/generic/style";
import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

const ProductAnalyticsChart = React.forwardRef((props) => {
  const { bottomPerforming, colorData, isKeyTakeAway, sizeData, stockUtilisation, typeData, topPerforming } = props;

  const materialDataPie = {
    labels: typeData[0],
    datasets: [
      {
        label: "# of Votes",
        data: typeData[1],
        backgroundColor: [
          "#deebf7",
          "#9ecae1",
          "#3282bd",
          "rgba(75, 192, 192, 0.2)",
          "rgba(153, 102, 255, 0.2)",
          "rgba(255, 159, 64, 0.2)",
        ],
        borderColor: [
          "#deebf7",
          "#9ecae1",
          "#3282bd",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const colorDataPie = {
    labels: colorData[0],
    datasets: [
      {
        label: "# of Votes",
        data: colorData[1],
        backgroundColor: [
          "#deebf7",
          "#9ecae1",
          "#3282bd",
          "rgba(75, 192, 192, 0.2)",
          "rgba(153, 102, 255, 0.2)",
          "rgba(255, 159, 64, 0.2)",
        ],
        borderColor: [
          "#deebf7",
          "#9ecae1",
          "#3282bd",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const sizeDataPie = {
    labels: sizeData[0],
    datasets: [
      {
        label: "# of Votes",
        data: sizeData[1],
        backgroundColor: [
          "#deebf7",
          "#9ecae1",
          "#3282bd",
          "rgba(75, 192, 192, 0.2)",
          "rgba(153, 102, 255, 0.2)",
          "rgba(255, 159, 64, 0.2)",
        ],
        borderColor: [
          "#deebf7",
          "#9ecae1",
          "#3282bd",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const [sizePopular] = sizeData;
  const [colorPopular] = colorData;
  const [typePopular] = typeData;

  const isSizePopular = !!(sizePopular && sizePopular.length);
  const isColorPopular = !!(colorPopular && colorPopular.length);
  const isTypePopular = !!(typePopular && typePopular.length);

  return (
    <ProductAnalyticStyle>
      <BlockStack gap="400">
        <Card>
          <Text>Top Three Performing Products</Text>
          <br />
          <InlineStack align="space-evenly">
            {(topPerforming &&
              topPerforming.length &&
              (topPerforming || []).map((data) => {
                return (
                  <Card>
                    <InlineStack blockAlign="center" gap="400">
                      {/* <img alt="Product" src={data.image ? data.image : constant.NOIMAGESNAP} /> */}
                      <Thumbnail size="large" source={data.image ? data.image : constant.NOIMAGESNAP} />
                      <BlockStack>
                        <Text variant="headingMd" as="h2">
                          {data.title}
                        </Text>
                        {`Order : ${" "} ${data.orderCount}`}
                      </BlockStack>
                    </InlineStack>
                  </Card>
                );
              })) || <p>No Data Available</p>}
          </InlineStack>
        </Card>
        <Card>
          <Text>Bottom Two Performing Products</Text>
          <br />
          <InlineStack align="space-evenly">
            {(bottomPerforming &&
              bottomPerforming.length &&
              (bottomPerforming || []).map((data) => {
                return (
                  <Card>
                    <InlineStack blockAlign="center" gap="400">
                      {/* <img alt="Product" src={data.image ? data.image : constant.NOIMAGESNAP} /> */}
                      <Thumbnail size="large" source={data.image ? data.image : constant.NOIMAGESNAP} />

                      <BlockStack>
                        <Text variant="headingMd" as="h2">
                          {data.title}
                        </Text>
                        {`Order : ${" "} ${data.orderCount}`}
                      </BlockStack>
                    </InlineStack>
                  </Card>
                );
              })) || <p>No Data Available</p>}
          </InlineStack>
        </Card>
        <Card>
          <BlockStack inlineAlign="center">
            <h2 className="Polaris-Text graph-heading"> Stock Utilisation </h2>

            <PieChart
              data={[{ value: stockUtilisation, color: "#9ecae1" }]}
              totalValue={100}
              lineWidth={20}
              label={({ dataEntry }) => `${dataEntry.value}%`}
              labelStyle={{
                fontSize: "20px",
                fontFamily: "sans-serif",
                // fill: "#666",
              }}
              labelPosition={0}
              style={{ height: "200px" }}
              //   startAngle={360}
              background="#ccc"
            />
            <p>
              {`Great job! ${stockUtilisation}%
                      of your stock is being utilised`}
            </p>
            {/* <div> */}
            <h2 className="Polaris-Text graph-heading"> Key Take Aways </h2>
            {(isKeyTakeAway && (
              <div style={{ display: "flex", justifyContent: "space-around" }}>
                {isSizePopular && (
                  <div>
                    <CustomPieChart data={sizeDataPie} />
                    <span className="graph-title">{sizePopular[1] ? baseHelper.ucFirst(sizePopular[1]) : "Size"}</span>
                    <Text as="span" tone="subdued">
                      Was your most popularly rented size
                    </Text>
                  </div>
                )}
                {isColorPopular && (
                  <div>
                    <CustomPieChart data={colorDataPie} />
                    <span className="graph-title">
                      {colorPopular[1] ? baseHelper.ucFirst(colorPopular[1]) : "Color"}
                    </span>
                    <Text as="span" tone="subdued">
                      Was your most popularly rented color
                    </Text>
                  </div>
                )}
                {isTypePopular && (
                  <div>
                    <CustomPieChart data={materialDataPie} />
                    <span className="graph-title">{typePopular[1] ? baseHelper.ucFirst(typePopular[1]) : "Type"}</span>
                    <Text as="span" tone="subdued">
                      Was your most popularly rented catogary
                    </Text>
                  </div>
                )}
              </div>
            )) ||
              "No Data Available"}
            {/* </div> */}
          </BlockStack>
        </Card>
      </BlockStack>
    </ProductAnalyticStyle>
  );
});

export default ProductAnalyticsChart;
